/** @format */

import { Component, OnInit } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
} from '@richardlt/ng2-semantic-ui';
import { ChatService } from '../../services';

interface INewChatModalContext {
  services: any;
}

@Component({
  selector: 'app-new-chat-modal',
  templateUrl: './new-chat-modal.component.html',
  styleUrls: ['./new-chat-modal.component.scss'],
})
export class NewChatModalComponent implements OnInit {
  user: any;
  organizationId: any;

  error: any;
  success: any;
  pending: boolean = false;
  selectedServiceTypeName: string;

  servicesAndSubGroupsForm: FormGroup;
  services: FormGroup;
  selectedServiceType: string = '';
  selectedServiceSubType: string = '';

  allTopics;
  allSubTopics;
  filteredSubTopics;
  constructor(
    public modal: SuiModal<INewChatModalContext, void, void>,
    private router: Router,
    private fb: FormBuilder,
    private chatService: ChatService
  ) {
    this.user = JSON.parse(window.localStorage.getItem('user'));
    this.organizationId = this.user['organizationId'];
    this.servicesAndSubGroupsForm = fb.group({
      serviceType: [''],
      subServiceType: [''],
    });
  }

  ngOnInit(): void {
    this.getData();
  }

  createSession() {
    this.pending = true;
    this.chatService
      .createChatSession({
        subTopicId: this.servicesAndSubGroupsForm.value.subServiceType,
        organizationId: this.organizationId.organizationId,
        body: {},
      })
      .subscribe(
        (res) => {
          this.pending = false;
          this.success = 'Chat session Successfully created';
          setTimeout(() => {
            this.modal.approve(null);
          }, 2000);
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.message
            ? error.error.message
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }

  getData(): void {
    this.pending = true;
    this.chatService.getAllChatTopics({}).subscribe(
      (res) => {
        this.allTopics = res;
        this.getSub();
      },
      (error) => {
        console.log(error);
        this.pending = false;
      }
    );
  }

  getSub(): void {
    this.pending = true;
    this.chatService.getAllChatSubTopics({}).subscribe(
      (res) => {
        this.allSubTopics = res;
        this.pending = false;
      },
      (error) => {
        this.pending = false;
        this.error = error.error.errorMessage
          ? error.error.errorMessage
          : error.error.error
          ? error.error.error
          : error.error
          ? error.error
          : error;
      }
    );
  }

  getAssignedSubTopics(): void {
    this.chatService
      .getAssignedChatSubTopicsPerUser({
        appUserId: this.user['appUserId'],
      })
      .subscribe(
        (res) => {
          // this.allTopics = res;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  submit() {
    if (this.servicesAndSubGroupsForm.valid) {
      this.createSession();
    }
    // this.router.navigate(
    //   [
    //     '/contractor/chat-window',
    //     1,
    //     // this.organizationId,
    //     'conversation-screen',
    //   ],
    //   {
    //     queryParams: {
    //       id: 5,
    //       acronym: this.getAcronym(this.selectedServiceType),
    //       serviceType: this.getName(this.selectedServiceType),
    //       serviceSubType: this.getName(this.selectedServiceSubType),
    //       lastActivityDate: Date.now().toString(),
    //     },
    //   }
    // );
    // this.modal.approve();
  }

  changeType(topicId) {
    this.selectedServiceType = topicId;
    console.log(this.selectedServiceType, this.allSubTopics, 'type');
    this.filteredSubTopics = this.allSubTopics.filter((item) => {
      return item.topic.topicId === topicId;
    });
  }

  dataToJSON(data: any) {
    return JSON.parse(data);
  }
}

export class NewChatModal extends ComponentModalConfig<
  INewChatModalContext,
  void,
  void
> {
  constructor(services: any, size: ModalSize = ModalSize.Mini) {
    super(NewChatModalComponent, { services });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
